import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'edge-global-hero',
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.scss']
})
export class GlobalHeroComponent implements OnInit {
  @Input() image: string = '';
  @Input() logo: string = '';
  @Input() tagline: string = '';
  @Input() socialIcons: Array<any>;
  trustedImage: any;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    const imagePath = `url('../assets/images/home/noise.png'), url('${this.image}')`;
    this.trustedImage = this.sanitizer.bypassSecurityTrustStyle(imagePath);
  }
}
